import { classNames } from 'primereact/utils'
import { InputIconPassThroughOptions } from 'primereact/inputicon'

export const inputIconConfig: InputIconPassThroughOptions = {
  root: ({ context }: any) => ({
    className: classNames('absolute top-1/2', {
      'left-2': context.iconPosition === 'left',
      'right-2': context.iconPosition === 'right',
    }),
  }),
}
